export default {
    parts: [
        'container',
        'heading',
        'carousel',
        'tile',
        'tileLink',
        'media',
        'image',
        'creator',
        'arrow'
    ],
    baseStyle: {
        container: {
            width: '100%',
            paddingTop: {base: '50px', lg: '64px'}
        },
        heading: {
            marginBottom: '16px'
        },
        carousel: {
            position: 'relative',
            overflow: 'hidden',
            mx: {base: '-16px', md: 0}
        },
        tile: {
            width: '100%'
        },
        // Mirrors the landing page UgcTile parts (link / mediaContainer / image /
        // caption) so a PDP tile and a landing tile render identically.
        tileLink: {
            display: 'block',
            textDecoration: 'none',
            _hover: {textDecoration: 'none'},
            _focusVisible: {
                outline: '2px solid',
                outlineColor: 'black',
                outlineOffset: '2px'
            }
        },
        media: {
            position: 'relative',
            width: '100%',
            aspectRatio: {base: '2 / 3', lg: '17 / 25'},
            overflow: 'hidden'
        },
        image: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block'
        },
        creator: {
            marginTop: '8px',
            fontSize: {base: '12px', lg: '14px'},
            color: 'black'
        },
        arrow: {
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 2,
            display: {base: 'none', lg: 'flex'},
            alignItems: 'center',
            justifyContent: 'center',
            width: '40px',
            height: '40px',
            padding: 0,
            border: 'none',
            cursor: 'pointer',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            backdropFilter: 'blur(10px)',
            _hover: {backgroundColor: 'webTheme.backgroundDefault'}
        }
    }
}
